<script type="text/javascript">
  export default {
    props: ['website'],
    data() {
      return {
        video: false,
        demo: 1,

        buttons: [
          {color: 'blue', title: "I'm Buying", active: false},
          {color: 'indigo', title: "Selling and Buying", active: false},
          {color: 'yellow', title: "Black Road", active: false},
          {color: 'purple', title: "Not Sure", active: false},
          {color: 'pink', title: "The Brown", active: false},
          {color: 'red', title: "Dog Ran", active: false},
          {color: 'orange', title: "Across The", active: false},
          {color: 'green', title: "To Catch The", active: false},
          {color: 'teal', title: "I'm Selling", active: false},
          {color: 'cyan', title: "I'm Buying", active: false},
          {color: 'warning', title: "Not Sure", active: false},
          {color: 'success', title: "The Brown", active: false},
          {color: 'info', title: "Dog Ran", active: false},
          {color: 'danger', title: "Across The", active: false},
          {color: 'dark', title: "I'm Selling", active: false},
        ],
      }
    },
    created() {

    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <w-site-navbar
      :website="website"
      :static="1"
    ></w-site-navbar>
    <main>

      <section class="">
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" style="background-image: url(https://s3.revinre.com/website/Development/background_09.jpg);"></div>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 bg-revinre _o-9"></div>
        <div class="container-fluid pt-13 pb-12 m_py-35">
          <div class="row justify-content-center">
            <div class="col-lg-5">
              <div class="home-content mb-4">
                <h1 class="mb-3 text-black _f-s-70" data-aos="fade-zoom-in">Sell your home Save thousands</h1>
                <p class="text-black"  data-aos="fade-zoom-in">0% Listing fee | Average savings of $14,250 | 4.7 Star rating on Google</p>
                <div class="row mt-5 pt-5">
                  <div class="col-sm-5 px-sm-1"><a data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-black" @click="video ? video = false : video = true">Get Started</a></div>
                  </div>
              </div>
            </div>
            <div class="col-sm-7">
              <div class="position-relative ml-5 overflow-hidden bg-black" style="padding-top: 53%;box-shadow: 0px 0px 10px rgba(0,0,0,0.9);border-radius: 5px;">
                <div v-if="!video" class="position-absolute _pos-t-0 _pos-r-0 _pos-b-0 _pos-l-0 _c-pointer" @click="video ? video = false : video = true">
                  <img src="https://revinre.coryallen.app/storage/fm/revinre-nc/test.png" style="width:100%;height:100%;">
                  <div class="position-absolute bg-white" style="top: 46%;left: 48%;width: 45px;height: 45px;"></div>
                  <Icon icon="ri:youtube-fill" class="position-absolute" height="100" style="top:40%;left:44%;color:#ff0000;" />
                </div>
                <div v-else class="position-absolute _pos-t-0 _pos-r-0 _pos-b-0 _pos-l-0">
                  <iframe src="https://www.youtube.com/embed/SglNxlFUOjM?si=yBI_npIqJGyO4RzW&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen style="width:100%;height:100%;"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="position-absolute _pos-l-0 _pos-b-0 _pos-r-0 text-center">
          <ul class="list-inline">
            <li class="list-inline-item mx-3" v-tippy content="Visit us on Facebook"><a class="text-black" data-aos="fade-zoom-in"><Icon icon="ri:facebook-fill" height="20"></Icon></a></li>
            <li class="list-inline-item mx-3" v-tippy content="Visit us on Twitter"><a class="text-black" data-aos="fade-zoom-in"><Icon icon="ri:twitter-line" height="20"></Icon></a></li>
            <li class="list-inline-item mx-3" v-tippy content="Visit us on Instagram"><a class="text-black" data-aos="fade-zoom-in"><Icon icon="ri:instagram-line" height="20"></Icon></a></li>
            <li class="list-inline-item mx-3" v-tippy content="Visit us on YouTube"><a class="text-black" data-aos="fade-zoom-in"><Icon icon="ri:youtube-line" height="20"></Icon></a></li>
          </ul>
        </div>
      </section>


      <section class="bg-gray-100">
        <div class="container-fluid py-5">
          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:cactus-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3">Are you interested in buying or selling?</h2>
            <p class="text-pre-wrap">Discover how we can help by ansering a few simple questions.</p>
          </div>
          <div class="row justify-content-center">
            <div class="col _w-n-255 _w-m-480 mb-4">
              <a class="text-inherit text-hover-inherit h-100">
                <div class="card grow text-center h-100 bg-white">
                  <div class="px-5 pt-5">
                    <img src="/storage/fm/revinre-nc/clip art/Sell on your own.png" class="img-fluid mx-auto d-block">
                  </div>
                  <div class="p-4">
                    <h3 class="h2 mb-3">Customized Services</h3>
                    <p class="mb-3">REVINRE's customized services charge a fixed rate regardless of the property's selling price, offering potential cost savings.</p>
                    <button type="button" class="btn btn-lg btn-revinre">Get Started</button>
                  </div>
                </div>
              </a>
            </div>
            <div class="col _w-n-255 _w-m-480 mb-4">
              <a class="text-inherit text-hover-inherit h-100">
                <div class="card grow text-center h-100 bg-white">
                  <div class="px-5 pt-5">
                    <img src="/storage/fm/revinre-nc/clip art/Sell with an agent.png" class="img-fluid mx-auto d-block">
                  </div>
                  <div class="p-4">
                    <h3 class="h2 mb-3">Full Services</h3>
                    <p class="mb-3">REVINRE's full services, however, typically operate on commission-based models, with agents receiving a percentage of the sale price.</p>
                    <button type="button" class="btn btn-lg btn-revinre">Get Started</button>
                  </div>
                </div>
              </a>
            </div>
            <div class="col _w-n-255 _w-m-480 mb-4">
              <a class="text-inherit text-hover-inherit h-100">
                <div class="card grow text-center h-100 border border-gray-400 bg-lighten-success">
                  <div class="px-5 pt-5">
                    <img src="/storage/fm/revinre-nc/clip art/options.png" class="img-fluid mx-auto d-block">
                  </div>
                  <div class="p-4">
                    <h3 class="h2 mb-3">Not Sure?</h3>
                    <p class="mb-3">If you are unsure what the best path would be for you, we can help you figure it out by answering a few simple questions.</p>
                    <button type="button" class="btn btn-lg btn-success text-black">Start Quiz</button>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>


      <section class="section">
        <div class="container-fluid py-5">
          <div class="row justify-content-center text-center">
            <div class="col-lg-6">
              <div class="py-4 position-relative mb-5 font-weight-bolder">
                <div class="progress _h-7 mt-2">
                  <div class="progress-bar progress-bar-striped progress-bar-animated bg-revinre" style="width:0%"></div>
                </div>
                <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0">
                  <div class="row p-3 _lh-30 _m-l-n-18p _m-r-n-18p">
                    <div class="col-3 p-0 text-center" @click="demo = 1"><span class="d-inline-block rounded-circle _w-40 _h-40 border _b-s-4 bg-black border-black text-white">1</span></div>
                    <div class="col-3 p-0 text-center" @click="demo = 2"><span class="d-inline-block rounded-circle _w-40 _h-40 border _b-s-4 bg-white border-black text-black">2</span></div>
                    <div class="col-3 p-0 text-center" @click="demo = 3"><span class="d-inline-block rounded-circle _w-40 _h-40 border _b-s-4 bg-white border-black text-black">3</span></div>
                    <div class="col-3 p-0 text-center" @click="demo = 4"><span class="d-inline-block rounded-circle _w-40 _h-40 border _b-s-4 bg-white border-black text-black">4</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-center text-center">
            <div class="col-lg-8">
              <h2 class="h1">Are you interested in buying or selling?</h2>
              <p class="text-muted mb-5">Testing possible quiz designs. Click through to see the different designs.</p>
            </div>
          </div>
          <div v-if="demo == 1" class="row justify-content-center text-center">
            <div class="col-lg-8">
              <div class="row justify-content-center">
                <div class="col-sm-5 mb-4">
                  <button type="button" @click="demo = 2" class="btn btn-block h-100 rounded border border-muted bg-hover-revinre grow text-black px-5 py-3 _box-shadow-0-1-4-b-2">
                    <h1 class="my-2">Selling</h1>
                    <img src="https://s3.revinre.com/website/Clipart/real-estate-house-icon.png" alt="">
                  </button>
                </div>
                <div class="col-sm-1"></div>
                <div class="col-sm-5 mb-4">
                  <button type="button" @click="demo = 2" class="btn btn-block h-100 rounded border border-muted bg-hover-revinre grow text-black px-5 py-3 _box-shadow-0-1-4-b-2">
                    <h1 class="my-2">Buying</h1>
                    <img src="https://s3.revinre.com/website/Clipart/gpa-icon.png" alt="">
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="demo == 2" class="row justify-content-center text-center">
            <div class="col-lg-4">
              <button type="button" @click="demo = 3" class="btn btn-block btn-lg btn-outline-black mb-3">Selling</button>
              <button type="button" @click="demo = 3" class="btn btn-block btn-lg btn-outline-black mb-3">Buying</button>
            </div>
          </div>
          <div v-if="demo == 3" class="row justify-content-center text-center">
            <div class="col-lg-8">
              <div class="row justify-content-center">
                <div class="col-sm-5 mb-4">
                  <button type="button" @click="demo = 4" class="btn btn-block h-100 rounded border _b-s-10 border-black bg-lighten-revinre bg-hover-revinre grow text-black p-5">
                    <h1 class="mb-4">Selling</h1>
                    <Icon icon="teenyicons:sign-outline" height="150" />
                  </button>
                </div>
                <div class="col-sm-1"></div>
                <div class="col-sm-5 mb-4">
                  <button type="button" @click="demo = 4" class="btn btn-block h-100 rounded border _b-s-10 border-black bg-lighten-revinre bg-hover-revinre grow text-black p-5">
                    <h1 class="mb-4">Buying</h1>
                    <Icon icon="fluent:key-multiple-20-regular" height="150" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="demo == 4" class="row justify-content-center">
            <div class="col-lg-9">
              <div class="row bg-gray-100 p-4">
                <div v-for="(btn, btn_i) in buttons" :key="btn_i" class="_w-200 _h-200 p-2">
                  <div type="button" @click="demo = 1" class="btn btn-block text-left h-100 rounded bg-white px-4 py-5 temp_hover_icon" :class="'bg-hover-'+btn.color">
                    <Icon icon="teenyicons:sign-outline" height="25" class="mb-3" :class="'text-'+btn.color" />
                    <h6>{{ btn.title }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section class="section bg-gray-100">
        <div class="container-fluid py-5">
          <div class="row justify-content-center text-center">
            <div class="col-lg-8">
              <Icon icon="ri:cactus-line" height="45" class="mb-2 text-revinre" />
              <h2 class="h1">Are you interested in buying or selling?</h2>
              <p class="text-muted mb-5">Testing one of the quiz designs above on a gray background.</p>
            </div>
          </div>
          <div class="row justify-content-center text-center">
            <div class="col-lg-9">
              <div class="row bg-gray-100 p-4">
                <div v-for="(btn, btn_i) in buttons" :key="btn_i" class="_w-200 _h-200 p-2">
                  <div @click="btn.active ? btn.active = false : btn.active = true" class=" btn btn-block text-left h-100 rounded px-4 py-5 temp_hover_icon _box-shadow-0-1-4-b-2" :class="'bg-hover-'+btn.color+' '+(btn.active ? 'on bg-'+btn.color : 'bg-white')">
                    <Icon icon="teenyicons:sign-outline" height="25" class="mb-3" :class="'text-'+btn.color" />
                    <h6>{{ btn.title }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      

    </main>

    <w-site-footer
      :website="website"
    ></w-site-footer>

  </section>
</template>

<style>
.temp_hover_icon:hover .iconify, .temp_hover_icon:hover h6, .temp_hover_icon.on .iconify, .temp_hover_icon.on h6 {
  color: white !important;
}
</style>